import { styled } from "@mui/material";
import { Box } from "@mui/system";
import { BRAND } from "themes";

export const styles = {
    mainContainer: {
        height: "0.7",
        width: 1,
        display: "flex",
        p: "5rem 7rem",
        flexDirection: "column",
        gap: "2rem",
    },
    heading: {
        color: "#000",
        fontSize: "4rem"
    },
    paraText: {
        color: "#000",
        fontSize: "2rem"
    },
    linkText: {
        fontSize: '1rem',
    },
    linkContainer: {
        display: "flex",
        gap: "0 2px"
    },
    mainCardSX: {
        maxWidth: { xs: 480, lg: 920 },
        width: "100%",
        margin: { md: 3 },
        borderRadius: "28px !important",
        overflow: "hidden",
        boxShadow: "0 30px 80px -36px rgba(27, 19, 64, 0.35)",
        border: `1px solid ${BRAND.border}`,
    }
}


const LoginWrapper = styled("div")(() => ({
    minHeight: "100vh",
    background: `radial-gradient(1200px 600px at -10% -20%, rgba(108, 60, 233, 0.18), transparent 55%),
      radial-gradient(900px 500px at 110% 120%, rgba(85, 70, 255, 0.16), transparent 50%),
      linear-gradient(180deg, #F7F5FF 0%, #EEF2F6 100%)`,
}));

const BrandPanel = styled(Box)(({ theme }) => ({
    height: "100%",
    minHeight: 520,
    padding: theme.spacing(5),
    borderRadius: 24,
    color: "#fff",
    background: `linear-gradient(160deg, ${BRAND.primary} 0%, ${BRAND.primaryDark} 55%, ${BRAND.secondary} 100%)`,
    boxShadow: "0 24px 60px -24px rgba(91, 47, 209, 0.55)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    overflow: "hidden",
    "&::after": {
        content: '""',
        position: "absolute",
        width: 280,
        height: 280,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.08)",
        right: -80,
        bottom: -90,
    },
}));

export { LoginWrapper, BrandPanel };
